import { Version } from "./Version";

const currentVersion = new Version(2, 5, 0);

export default currentVersion;
